import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import DonationStart from './DonationStart';
import DonationDetails from './DonationDetails';
import DonationSuccess from './DonationSuccess';

const Donation = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(donation|donation/start)"
                            name="DonationStart"
                            exact
                            component={DonationStart}
                        />
                        <Route
                            path="/donation/details"
                            name="DonationDetails"
                            exact
                            component={DonationDetails}
                        />
                        <Route
                            path="/donation/success"
                            name="DonationSuccess"
                            exact
                            component={DonationSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Donation;
